import NotFound from '../containers/NotFound';

export default {
  component: NotFound,
  path: '/*'
}